import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useAuth } from "../../Context/AuthContext";

const LogoutCallback = () => {
  const navigate = useNavigate();
  const { logout } = useAuth();

  useEffect(() => {
    // Cuando Cognito redirige aquí después del logout,
    // ya se ha cerrado la sesión en Cognito.
    // Solo necesitamos limpiar el estado local y redirigir al login.
    const handleLogout = async () => {
      try {
        // Asegurarse de que el estado local esté limpio
        await logout();
        
        // Redirigir al login
        navigate("/login", { replace: true });
      } catch (error) {
        console.error("Error en logout callback:", error);
        // Aún así redirigir al login
        navigate("/login", { replace: true });
      }
    };

    handleLogout();
  }, [logout, navigate]);

  return (
    <Box
      sx={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
      <Typography sx={{ mt: 2, color: "#666" }}>
        Cerrando sesión...
      </Typography>
    </Box>
  );
};

export default LogoutCallback;
